import { useTran } from "@/hooks";
import { Input } from "@/components/ui/input";
import { QUARTERS, MONTHS } from "../utils/period-constants";

/**
 * MetricCardPeriodicInputs - Quarterly or monthly target inputs
 */
const MetricCardPeriodicInputs = ({
  frequency,
  target,
  disclosure,
  onPeriodChange,
}) => {
  const { t } = useTran();

  if (!frequency || frequency === "annual") {
    return (
      <div className="space-y-3 rounded-radius bg-muted/40 p-3">
        <p className="text-sm text-muted-foreground">
          {t("This disclosure is tracked annually.")}
        </p>
      </div>
    );
  }

  if (frequency === "quarterly") {
    return (
      <div className="space-y-3 rounded-radius bg-muted/40 p-3">
        <label className="block text-sm font-medium text-foreground">
          {t("Quarterly Targets")}
        </label>
        <div className="grid grid-cols-2 gap-2">
          {QUARTERS.map((quarter, index) => (
            <div key={quarter} className="flex items-center gap-2">
              <span className="w-8 text-xs font-medium text-muted-foreground">
                {quarter}
              </span>
              <Input
                type="number"
                value={target?.quarterly?.[index] || ""}
                onChange={(event) => onPeriodChange(index, event.target.value)}
                placeholder="0"
                className="flex-1 text-sm"
              />
            </div>
          ))}
        </div>
        <p className="text-xs text-muted-foreground">
          {t("Total")}:{" "}
          {target?.quarterly
            ?.reduce((sum, val) => sum + (parseFloat(val) || 0), 0)
            .toFixed(2)}{" "}
          {disclosure.unit || ""}
        </p>
      </div>
    );
  }

  if (frequency === "monthly") {
    return (
      <div className="space-y-3 rounded-radius bg-muted/40 p-3">
        <label className="block text-sm font-medium text-foreground">
          {t("Monthly Targets")}
        </label>
        <div className="grid grid-cols-3 gap-2">
          {MONTHS.map((month, index) => (
            <div key={month} className="flex items-center gap-2">
              <span className="w-10 text-xs font-medium text-muted-foreground">
                {month}
              </span>
              <Input
                type="number"
                value={target?.monthly?.[index] || ""}
                onChange={(event) => onPeriodChange(index, event.target.value)}
                placeholder="0"
                className="flex-1 text-sm"
              />
            </div>
          ))}
        </div>
        <p className="text-xs text-muted-foreground">
          {t("Total")}:{" "}
          {target?.monthly
            ?.reduce((sum, val) => sum + (parseFloat(val) || 0), 0)
            .toFixed(2)}{" "}
          {disclosure.unit || ""}
        </p>
      </div>
    );
  }

  return null;
};

export default MetricCardPeriodicInputs;
